require('../../modules/es.typed-array.some');
